import $ from 'jquery';

export function accordionVacancy() {
    let accOpen = false
    $(".vacancy-items .vacancy-item").find(".text-wrapper").hide();

    $(".vacancy-items .vacancy-item .title-wrapper").on("click", function() {
        accOpen = !accOpen;

        if(!$(this).find(".plus").hasClass("open"))
        {
            $(this).parent().find(".text-wrapper").slideDown();
            $(this).find(".plus").toggleClass("open");
        }
        else { 
            $(this).parent().find(".text-wrapper").slideUp();
            $(this).find(".plus").toggleClass("open");
        }
        /* if(accOpen)
            $($($(this).parent()).parent()).css("height", $(itemWrapper).height() + 80 + $(itemTitleWrapper).height() + 20)
        else $($($(this).parent()).parent()).css("height", $(itemTitleWrapper).height() + 80)
        console.log(); */
        
    })
    $(window).resize(function () { 
        /* if(accOpen)
            $($($(this).parent()).parent()).css("height", $(itemWrapper).height() + 80 + $(itemTitleWrapper).height() + 20)
        else $($($(this).parent()).parent()).css("height", 173) */
    });
}


// WEBPACK FOOTER //
// app/scripts/components/accordion-vacancy.js